
export const DAG_DECIMALS = 1e-8;